export const getColumns = (selectedField, applyAll, onChangeText) => {
  const columns = [
    {
      title: 'Product Name',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'SAP SKU',
      dataIndex: 'sku',
      key: 'sku',
    },
    {
      title: 'Store',
      dataIndex: 'store',
      key: 'store',
    },
  ];

  // if (selectedField) {
  //   columns.push({
  //     title: 'Description',
  //     dataIndex: 'description',
  //     key: 'description',
  //     render: (_, record, index) => (
  //       <textarea
  //         placeholder="Textarea"
  //         value={applyAll ? applyAll : record.description || ''}
  //         onChange={(e) => onChangeText(e.target.value, index)}
  //         style={{ width: '100%' }}
  //       />
  //     ),
  //   });
  // }

  return columns;
};
